export default __webpack_public_path__ + "static/media/lookup-logo_light.0bf56262.svg";